import { React, useEffect, useState, Fragment } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

import { Box, Button, Select, MenuItem, TextField } from '@mui/material';
import * as roleService from "../../Role/api/api";
import * as roleMenuService from "../../RoleMenu/api/api";
import MyCard from '../../../shared/components/myCard';
import { DataGrid } from '@mui/x-data-grid';

import { toast } from 'react-toastify';
import MyLoading from "src/shared/components/myLoading";




export default function RoleMenu() {
 const functionSele =(ee)=>{
console.log(ee,"ee")
 }
    
useEffect(() => {
    const pagerInputModel = {
        "pageNumber": 1,
        "pageSize": 100
    }
    roleService.list(pagerInputModel).then((res) => {
        const { isSuccess,message, data: roleData } = res;
        if (isSuccess) {
            setRoleList(roleData);
        } else {
            toast.error(message);
            console.log(res, "roleData-hata");
        }        
    });

  
}, [])

const [isLoading, setIsLoading] = useState(false);

const [rolMenuData, setRolMenuData] = useState([]);

const [selectionModel, setSelectionModel] = useState([]);

const [roleMenuList, setRoleMenuList] = useState([]);
const [menuList, setMenuList] = useState([]);

// useEffect(() => {
//     var difference;
//   if(selectionModel.length>prevSelectionModel.length)
//   {
//          difference = selectionModel.filter(x => !prevSelectionModel.includes(x));
//          console.log("eklendi");
        
//   }
//     else  if(selectionModel.length<prevSelectionModel.length)
//     {
//            difference = prevSelectionModel.filter(x => !selectionModel.includes(x));
//            console.log("cikarildi");
//     }
// console.log(selectionModel,prevSelectionModel,difference);

//  setPrevSelectionModel(selectionModel)
// }, [selectionModel])


useEffect(() => {
    //ilk yuklemede tum menuler 
    const pagerInputModel = {
               
    }
    roleMenuService.menulist(pagerInputModel).then((res) => {
        const { isSuccess,message, data: menuData } = res;
        if (isSuccess) {
            setMenuList(menuData);
        } else {
            toast.error(message);
            console.log(res, "menulist-hata");
        }        
    });
}, [])

const addMenuToRole =(menuId)=>{
    setIsLoading(true);
    const pagerInputModel = {
        "roleId": role,
        "menuId":menuId[0]           
    }
    roleMenuService.create(pagerInputModel).then((res) => {
        const { isSuccess,message, data: rolMenuData } = res;
        if (isSuccess ) {
            toast.success("Eklendi.");

        } else {
            toast.error(message);
            console.log(res, "roleMenu create-hata");
        }   
        setIsLoading(false);
     
    });
}
const deleteMenuFromRole =(menuId)=>{
    setIsLoading(true);

    var id= rolMenuData.find(p=>p.menuId==menuId).id;
    const pagerInputModel = {
        "id":id           
    }
    roleMenuService.deleteItem(pagerInputModel).then((res) => {
        const { isSuccess,message, data: rolMenuData } = res;
        if (isSuccess ) {
            toast.success("Silindi.");
        } else {
            toast.error(message);
            console.log(res, "deleteItem-hata");
        }     
        setIsLoading(false);
   
    });
}


const [roleList, setRoleList] = useState([]);
    const [role, setRole] = useState(0);

    function roleSelectChangeHandler(event) {
        setRole(event.target.value);
        const pagerInputModel = {
            "rolId": event.target.value           
        }
        roleMenuService.getListByRolId(pagerInputModel).then((res) => {
            const { isSuccess,message, data: rData } = res;
            if (isSuccess || message=='Data is empty') {
                setRolMenuData(rData)
                setSelectionModel(rData.map(p=>p.menuId))
            } else {
                toast.error(message);
                console.log(res, "roleMenuList-hata");
            }        
        });
       
    }

    const columns = [
        { field: 'name', headerName: 'name', width:200 },
        { field: 'menuUrl', headerName: 'menuUrl', width: 300 },
        { field: 'definitionCode', headerName: 'definitionCode', width: 200 }
      ]



  return (
    <>
     <MyCard header="Role Menü Ekle/Çıkar">
    <Select fullWidth
                    labelId="lblRoleId"
                    id="selectRole"
                    value={role}
                    label="Rol"
                    size="small"
                    onChange={(event) => roleSelectChangeHandler(event)}
                >
                    {
                        roleList.map((itm) =>
                            <MenuItem value={itm.id}>{itm.name}</MenuItem>
                        )

                    }
                </Select>
                {isLoading && <MyLoading></MyLoading>}
                <div style={{ height: 700, width: '100%',marginTop:20 }}>
                    
              { role !=0  && <DataGrid
        rows={menuList}
        columns={columns}
        checkboxSelection
       
                onSelectionModelChange={(newSelectionModel) => {
                    console.log(selectionModel,newSelectionModel)
var difference;
                    if(selectionModel.length<newSelectionModel.length)
                    {
                           difference = newSelectionModel.filter(x => !selectionModel.includes(x));
                           console.log(difference,"eklendi");
                           addMenuToRole(difference)
                          
                    }
                      else  if(selectionModel.length>newSelectionModel.length)
                      {
                             difference = selectionModel.filter(x => !newSelectionModel.includes(x));
                             deleteMenuFromRole(difference);
                             console.log(difference,"cikarildi");
                      }


            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
         pageSize={80}
      />}
      </div>
    </MyCard>
    
    
    </>
  )
}
